import { ROUTES } from "@nf/constants";
import { useTranslation } from "next-i18next";
import dynamic from "next/dynamic";

import styles from "./NoSubscriptionsContainer.module.scss";

const SettingsSubscriptionButton = dynamic(
  import("components/Settings/SettingsSubscriptionButton")
);

export const NoSubscriptionsContainer = () => {
  const { t } = useTranslation("translations");
  return (
    <div className={styles.container}>
      <p className={styles.text}>{t("web_subscription_no_subscription")}</p>
      <SettingsSubscriptionButton
        variant="primary"
        href={ROUTES.PAYMENT_SUBSCRIPTION}
      >
        {t("web_subscription_no_subscription_button")}
      </SettingsSubscriptionButton>
    </div>
  );
};

export default NoSubscriptionsContainer;
